// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaymentMethod-module-paymentMethodItem-AxSVK{flex:0 1 33%;border:1px solid #eee;border-radius:8px;display:grid;padding-block:12px;padding-inline:17px;grid-template-columns:auto auto;min-width:100%}.PaymentMethod-module-paymentMethodImg-TvWyr{display:block;max-width:50px;place-self:center end}.PaymentMethod-module-popoverIcon-mc713{-webkit-padding-start:5px;padding-inline-start:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentMethodItem": "PaymentMethod-module-paymentMethodItem-AxSVK",
	"paymentMethodImg": "PaymentMethod-module-paymentMethodImg-TvWyr",
	"popoverIcon": "PaymentMethod-module-popoverIcon-mc713"
};
export default ___CSS_LOADER_EXPORT___;
